import { EscrowTransactionFields } from "../EscrowTransactionFields";
import { DataSource, Label, Layout, Panel, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEscrowTransaction extends Layout {
    labelBatch: Label;
    layoutEscrowTransactionFields: EscrowTransactionFields;
    layoutEscrowTransactionFieldsAdd: EscrowTransactionFields;
    layoutGLDristribution: Layout;
    panelBatch: Panel;
    panelGLDistribution: Panel;
    sourceEscrowTransaction: DataSource;
    sourceGLDistribution: DataSource;
    tabGLDistribution: Tab;
    tabGeneral: Tab;
    tabsetEscrow: Tabset;
    textboxBatchCode: Textbox;
    textboxBatchNumber: Textbox;
    textboxBatchSeq: Textbox;
}
